/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/208-eye-plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 2h-2V0h-2v2h-2v2h2v2h2V4h2z"/><path pid="1" d="M13.498 6.969c.288.32.55.665.782 1.031a7.594 7.594 0 01-2.335 2.348 7.326 7.326 0 01-7.889 0A7.626 7.626 0 011.721 8a7.594 7.594 0 012.52-2.462A4 4 0 1012 6.907v-.032a4.002 4.002 0 01-2.999-3.817A8.94 8.94 0 008 3.001c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5a9.217 9.217 0 00-.979-1.548 3.973 3.973 0 01-1.523.517zM6.5 5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 016.5 5z"/>'
  }
})
